import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FedEvent } from '../../types/entities';

import { FedCalendarState, initialState } from './state';

const mantraSlice = createSlice({
  name: 'fed-calendar',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: FedCalendarState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: FedCalendarState, action: PayloadAction<FedEvent[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.events = action.payload;
    },
    add: (state: FedCalendarState, action: PayloadAction<FedEvent[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.events = [...state.events, ...action.payload];
    },
    fail: (state: FedCalendarState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.events = [];
    }
  }
});

const { actions, reducer } = mantraSlice;
export const { reset, loading, success, add, fail } = actions;
export default reducer;
